<script setup lang="ts">
import { ref, onMounted } from 'vue'

import { SpeckleLoginButton } from '@haskoning/vue-speckle'

const redirectUrl = ref<string | null>(null)

onMounted(() => (redirectUrl.value = window.location.href))
</script>

<template>
  <v-card border="opacity-35 sm" variant="text">
    <v-card-title>Speckle login required</v-card-title>
    <v-card-subtitle>
      Log in to Speckle to select a project and link calculations to models.
    </v-card-subtitle>

    <v-alert type="info" variant="tonal" density="compact" class="mx-4 mt-4">
      You will be redirected to Speckle to log in and brought back to this page afterwards.
    </v-alert>

    <v-card-actions class="pa-4">
      <SpeckleLoginButton :redirect-url="redirectUrl" />
    </v-card-actions>
  </v-card>
</template>
